export const MODAL_CONTENT_MIN_HEIGHT = '300px';
